<template>
    <div class="content">
        <el-button
			:type="getType(item.id)" class="button" size="mini"
			v-for="item in tags" :key="item.id"
			v-if="item.type==0 && item.name !== '其他'"
			@click="toggleSelection(item.id)">
			{{item.name}}
		</el-button>
        <el-button
			:type="getType(item.id)" class="button" size="mini"
			v-for="item in tags" :key="item.id"
			v-if="item.type==0 && item.name === '其他'"
			@click="toggleSelection(item.id)">
			{{item.name}}
		</el-button>
    </div>
</template>

<script>
	export default {
		props:['value'],
		data(){
			return {
				selection:[]
            }
        },
		computed: {
			tags(){
				return this.$store.state.tags.list||[]
			}
		},
        methods:{
			toggleSelection(id){
				const index = this.selection.indexOf(id)
				if(index>=0){
					this.selection.splice(index, 1)
				}else{
					this.selection.push(id)
				}
			},
			getType(id){
				return this.selection.indexOf(id)>=0? 'primary':'default'
			}
        },
        watch:{
			value(value){
			    this.selection = value
            },
			selection(){
				this.$emit('input', this.selection)
            }
        }
    }
</script>

<style lang="scss" scoped>
  .content {
  	:global(.el-button) {
	  border: none;
	  padding: 5px 11px 6px 12px;
	  margin: 0 8px 0 0;
	  font-size: 12px;
	  color: #75808B;
	}
    :global(.el-button--primary) {
	  background: #F4F6F8;
	  color: #3fb7ff;
	}
    :global(.el-button + .el-button) {
      margin: 0 8px 0 0;
	}
  }

</style>
